import { render, staticRenderFns } from "./program-view.vue?vue&type=template&id=2100f60b&"
import script from "./program-view.vue?vue&type=script&lang=js&"
export * from "./program-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports